export function Image({ imgLink, imgAlt, className, assetOrWeb }) {
    return (
      imgLink &&
      <img
        src={assetOrWeb ? imgLink : process.env.REACT_APP_SPACES_URL + imgLink}
        alt={imgAlt}
        className={className}
      />
    )
  }